<template>
    <v-container fluid>
        <v-form class="pa-0" ref="form" v-model="validForm" lazy-validation>
            <v-toolbar flat color="transparent">
                <v-toolbar-title>
                    <h2 v-if="!$route.params.id" :class="$vuetify.theme.isDark ? 'white--text' : ''">
                        Crear Tipo
                    </h2>

                    <h2 v-else :class="$vuetify.theme.isDark ? 'white--text' : ''">
                        <v-btn fab small elevation="0" color="secondary" @click="showLog()">
                            <v-icon>mdi-post</v-icon>
                        </v-btn> Editar Tipo
                    </h2>
                </v-toolbar-title>
                <v-spacer/>

                <v-btn :disabled="!validForm" class="mx-1" elevation="0" color="primary" rounded @click="validateForm">
                    Guardar
                </v-btn>

                <v-btn class="mx-1" elevation="0" color="error" rounded v-if="$route.params.id" @click="destroyDialog = true">
                    Desactivar
                </v-btn>
            </v-toolbar>

            <!-- Mostrar errores generales -->
            <v-alert v-if="errorMessage" type="error" dense class="mb-4">
                {{ errorMessage }}
            </v-alert>

            <v-row>
                <v-col cols="12" md="6">
                    <v-card>
                        <v-card-title class="pb-2">
                            <h4 :class="$vuetify.theme.isDark ? 'white--text' : ''">
                                <v-icon :color="$vuetify.theme.isDark ? 'white' :'secondary'">mdi-clipboard-text</v-icon>
                                Descripción
                            </h4>
                        </v-card-title>
                        <v-card-text>
                            <v-col>
                                <v-text-field 
                                    :rules="emptyRule" 
                                    :error="fieldErrors.name" 
                                    :error-messages="fieldErrors.name"
                                    hide-details 
                                    dense 
                                    outlined 
                                    v-model="payload.name" 
                                    label="Nombre"
                                ></v-text-field>
                            </v-col>
                            <v-col>
                                <v-text-field 
                                    :rules="emptyRule" 
                                    :error="fieldErrors.slug" 
                                    :error-messages="fieldErrors.slug"
                                    hide-details 
                                    dense 
                                    outlined 
                                    v-model="payload.slug" 
                                    label="Slug"
                                ></v-text-field>
                            </v-col>
                            <v-col>
                                <v-text-field 
                                    :rules="emptyRule" 
                                    :error="fieldErrors.abbreviation" 
                                    :error-messages="fieldErrors.abbreviation"
                                    hide-details 
                                    dense 
                                    outlined 
                                    v-model="payload.abbreviation" 
                                    label="Abreviación"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" class="px-6 py-0">
                                <v-row align="center" justify="center">
                                    <h4 class="mb-0 pr-3" :class="$vuetify.theme.isDark ? 'white--text' : ''">Activo:</h4>
                                    <v-switch :color="$vuetify.theme.isDark ? 'primary' : 'secondary'" v-model="payload.enabled"></v-switch>
                                </v-row>
                            </v-col>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>

            <v-dialog v-model="destroyDialog" max-width="400">
                <v-card>
                    <v-card-title class="headline">
                        ¿Estas seguro?
                    </v-card-title>

                    <v-card-text>
                        Una vez desactives el registro no se podrá recuperar.
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn rounded color="primary" text @click="destroyDialog = false">
                            Mejor no
                        </v-btn>
                        <v-btn elevation="0" class="pa-4" rounded color="error" @click="destroy">
                            Eliminar
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <logDialog ref="logDialog"></logDialog>
        </v-form>
    </v-container>
</template>

<script>
import logDialog from '../commons/LogViewer.vue'
export default {
    components: {
        logDialog
    },
    data(){
        return {
            destroyDialog: false,
            validForm: true,
            emptyRule: [v => !!v || 'Necesario'],
            errorMessage: null,
            fieldErrors: {
                name: null,
                slug: null,
                abbreviation: null
            },
            payload: {
                id: null,
                name: null,
                slug: null,
                abbreviation: null,
                enabled: true
            },
        }
    }, 
    methods: {
        clearErrors() {
            this.errorMessage = null;
            this.fieldErrors = {
                name: null,
                slug: null,
                abbreviation: null
            };
        },

        validateForm(){
            this.clearErrors(); // Limpiar errores anteriores
            if(this.$refs.form.validate()){
                (this.$route.params.id ? this.update() : this.store())
            }
        }, 

        create() {
            
        },

        edit(){
            this.$axios
                .get(`/admin/productTypes/${this.$route.params.id}/edit`)
                .then((response) => {
                    console.log(response);
                    this.payload = response.data.item
                })
        },

        store() {
            let formData = new FormData();
            Object.entries(this.payload).forEach(([key,value]) => {
                if(key === 'enabled'){
                    formData.append(key,value ? 1 : 0);
                } else {
                    formData.append(key, value);
                }
            });

            this.$axios
                .post('/admin/productTypes', formData)
                .then((response) => {
                    this.$store.commit('OPEN_SNACKBAR', response.data);
                    if(response.data.success) {
                        this.$router.push('/productTypes');
                    }
                })
                .catch((error) => {
                    this.handleError(error);
                });
        },

        update(){
            let formData = new FormData();

            Object.entries(this.payload).forEach(([key,value]) => {
                if(key === 'enabled'){
                    formData.append(key,value ? 1 : 0);
                } else {
                    formData.append(key,value);
                }
            });

            formData.append('_method', 'PUT')

            this.$axios
                .post(`/admin/productTypes/${this.$route.params.id}`, formData)
                .then((response) => {
                    this.$store.commit('OPEN_SNACKBAR', response.data);
                    if(response.data.success) {
                        this.$router.push('/productTypes');
                    }
                })
                .catch((error) => {
                    this.handleError(error);
                });
        },

        destroy(){
            let formData = new FormData();

            formData.append('enabled', 0);

            this.$axios
                .post(`/admin/productTypes/${this.$route.params.id}/desactivar`, formData)
                .then((response) => {
                    this.$store.commit('OPEN_SNACKBAR', response.data.message);
                    if(response.data.success){
                        this.$router.push('/productTypes');
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },

        handleError(error) {
            if (error.response && error.response.status === 422) {
                // Error de validación del backend
                const errors = error.response.data.content;
                
                // Limpiar errores anteriores
                this.clearErrors();
                
                // Mostrar errores de campos específicos
                if (errors && typeof errors === 'object') {
                    Object.keys(errors).forEach(field => {
                        if (this.fieldErrors.hasOwnProperty(field)) {
                            this.fieldErrors[field] = errors[field].join(', ');
                        }
                    });
                    
                    // Mostrar primer error como mensaje general
                    const firstError = Object.values(errors)[0];
                    if (firstError && firstError.length > 0) {
                        this.errorMessage = firstError[0];
                    }
                }
            } else {
                // Otro tipo de error
                this.errorMessage = 'Ha ocurrido un error inesperado. Por favor intenta nuevamente.';
                console.error('Error:', error);
            }
        },
        
        showLog() {
            // Tu método existente
        }
    },

    mounted() {
        if(this.$route.params.id){
            this.edit()
        } else {
            this.create()
        }
    }
}
</script>